import * as brand from './colors';
import { typography } from './typography';
import { shadows } from './shadows';
import { overrides } from './overrides';

export const styles = {
  palette: {
    primary: {
      main: brand.vamGray.main
    },
    secondary: {
      main: brand.vamBlue[500]
    }
  },
  typography,
  shadows,
  overrides
};
